<template>
<main>
    <section class="pb-5 min-vh-100 d-flex align-items-center">
        <div class="container-xl position-relative">
            <transition
            @before-enter="beforeEnter"
            @before-leave="beforeLeave"
            @enter="enter"
            @leave="leave"
            :css="false">

                <div class="row description position-relative text-white my-5 py-5" ref="cardDescription" v-if="$root.showDescrpition && data">
                    <div class="col-lg-3 col-md-4 ml-auto mb-md-0 mb-3"
                        v-if="$route.params.type == 'tarot'"
                    >
                        <div class="pulse-0">
                            <img :src="data.url" class="desc-img m-auto d-block mw-100 mh-100">
                        </div>
                    </div>
                    <div class="text-md-justify text-center d-flex align-items-center justify-content-center"
                        :class="$route.params.type == 'tarot' ? 'col-lg-6 col-md-7 mr-auto' : 'col-12'"
                    >
                        <div class="m-auto">
                            <h1 v-if="$route.params.type == 'tarot'" class="text-primary" v-html="data.title"></h1>
                            <h1 v-else-if="$route.params.type == 'numerology'" class="text-primary text-center display-1" v-html="data.number"></h1>
                            <div v-html="data.content" class="mb-3"></div>
                            <div class="share-wrapper mb-3 text-right">
                                <ShareNetwork
                                    network="facebook"
                                    :url="social.url"
                                    :title="social.title"
                                    class="btn btn-sm btn-primary"
                                >
                                    <span><iconShare />Udostępnij na Facebooku</span>
                                </ShareNetwork>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </section>
</main>
</template>

<script>
    import iconShare from '../icon/share';
    export default {
        data(){
            return {
                data: null,

                social:
                {
                    url: window.location.origin + '/share' + this.$route.path,
                    title: null,
                }
            }
        },
        mounted() {
            let _this = this;
            this.$root.showDescrpition = true;
            this.$root.isCardDesc = true;

            if(this.$route.params.type == 'tarot')
            {
                axios
                .get('/home/get', {
                    params:
                    {
                        'option': 'get_tarot',
                        'id': this.$route.params.id,
                    }
                }).then(response => {

                    this.data = response.data;
                    this.social.title = response.data.title;
                    this.social.image = window.location.origin + response.data.url;
                    // this.setMetaTags();
                });
            }
            else if(this.$route.params.type == 'numerology')
            {
                axios
                .get('/home/get', {
                    params:
                    {
                        'option': 'get_numerology',
                        'id': this.$route.params.id,
                    }
                }).then(response => {

                    this.data = response.data;
                    this.social.title = String(response.data.number);
                });
            }
        },
        components: {
            iconShare
        },
        methods: {
            beforeEnter: function (el) {
                el.style.opacity = 0,
                el.style.top = '-100px'
            },
            beforeLeave: function(el) {
                el.style.opacity = 1,
                el.style.top = 0
            },
            enter: function (el, done) {
                $(el).animate({
                    opacity: 1,
                    top: 0,
                },1000)
            },
            leave: function(el, done) {
                let _this = this;

                $(el).animate({
                    opacity: 0,
                    top: '-100px',
                },1000, function(el) {
                    _this.$root.isCardDesc = false;
                    _this.$router.push({ path: '/' });
                })
            },

            setMetaTags(){
                Object.keys(this.social).forEach(key => {

                    let meta = $("meta[data-vue-social=" + key + "]");
                    meta.attr("content", this.social[key]);
                })
            }
        },

    }
</script>
